import {Component} from '@angular/core';

@Component({
    selector: 't4-page-footer',
    templateUrl: './page-footer.component.html',
    styleUrls: [],
    standalone: false
})
export class PageFooterComponent {
  public year: number;
  constructor() {
    this.year = new Date().getFullYear();
  }
}
